import { topicWall } from "@/mocks/scandal";
import SectionHead from "./SectionHead";

export default function TopicWall() {
  return (
    <section id="topic" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          eyebrow="黑历史话题墙 / TAG WALL"
          title="人设、翻车、注水……话题越聊越厚"
          desc="整个档案库用话题来切。挑一个想了解的方向，点进去就是这一类型下的人物起底与深扒合集。"
        />

        {/* 高密度标签墙 */}
        <div className="mt-8 flex flex-wrap items-center gap-2 md:gap-2.5">
          {topicWall.map((t) => (
            <a
              key={t.topic}
              href="#topic"
              className="group flex items-center gap-1.5 whitespace-nowrap rounded-lg border border-foreground-950/8 bg-background-100/60 px-3 py-2 text-sm text-foreground-800 transition-all hover:border-primary-500 hover:bg-primary-50 hover:text-primary-700"
            >
              <span>#{t.topic}</span>
              <span className="font-label text-[11px] text-foreground-400 transition-colors group-hover:text-primary-500">
                {t.count}
              </span>
            </a>
          ))}
          <a
            href="#topic"
            className="flex items-center gap-1 whitespace-nowrap rounded-lg border border-dashed border-foreground-950/20 px-3 py-2 text-sm text-foreground-500 transition-colors hover:border-foreground-950/40 hover:text-foreground-950"
          >
            <i className="ri-add-line" />
            更多话题
          </a>
        </div>

        {/* 精选话题排行（三种视角） */}
        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {[
            { label: "增长最快", icon: "ri-arrow-up-circle-line", items: ["学历注水", "删评控评", "账号买卖"], note: "本周新增讨论最多" },
            { label: "存疑最多", icon: "ri-question-line", items: ["截图存疑", "人设代运营", "联动反噬"], note: "待核实线索占比偏高" },
            { label: "沉淀最久", icon: "ri-stack-line", items: ["人设崩塌", "带货翻车", "言论考古"], note: "历史档案沉淀最厚" },
          ].map((g) => (
            <div
              key={g.label}
              className="rounded-lg border border-foreground-950/6 bg-background-100/50 p-5 transition-colors hover:border-foreground-950/15"
            >
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={g.icon + " text-base"} />
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950">{g.label}</h3>
                <span className="ml-auto font-label text-[11px] text-foreground-400">{g.note}</span>
              </div>
              <ul className="mt-4 space-y-2.5">
                {g.items.map((it, i) => (
                  <li key={it} className="flex items-center gap-2.5">
                    <span className="w-4 font-heading text-sm font-bold text-foreground-300">{i + 1}</span>
                    <a
                      href="#topic"
                      className="flex-1 text-sm text-foreground-800 transition-colors hover:text-primary-700"
                    >
                      #{it}
                    </a>
                    <i className="ri-arrow-right-line text-xs text-foreground-300" />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}